export const enc = new TextEncoder();
export const dec = new TextDecoder();

export function toB64(u8: Uint8Array): string {
  return btoa(String.fromCharCode(...u8));
}

export function fromB64(b64: string): Uint8Array {
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}
